var render = function (_h,_vm) {var _c=_vm._c;return _c('img',{attrs:{"src":'/img/miniguitar' + (Math.floor(Math.random() * 6) + 1) + '.png'}})}
var staticRenderFns = []

export { render, staticRenderFns }